module.exports = __webpack_public_path__ + "media/components/country-flag/static/am-2fc77d16d218745676c68ca1a2a95bdb.svg";